module.exports = __webpack_public_path__ + "img/volgograd.1a315e23.png";